/*
  Ferien, die Tag für Tag erfasst wurden, sind mehrere UserHoliday-Zeilen.
  Im Raster werden sie trotzdem als EIN Balken gezeigt, wenn sie direkt
  aneinander anschliessen — nur in der Anzeige, die Daten bleiben getrennt.

  Zusammengefasst wird, was dieselbe Person, denselben Ferientyp und denselben
  Genehmigungsstand hat und lückenlos aufeinander folgt (Ende + 1 Tag = Beginn
  des nächsten). Ein Wochenende dazwischen trennt also.

  Die Gruppe trägt ihre Teile als `segments`. Bearbeitet wird immer ein Teil:
  der Tag unter dem Zeiger (Auswahl, Öffnen, Ziehen), beim Verlängern der
  erste bzw. letzte Teil — siehe ShiftplanMonthGrid.
*/

const DAY_MS = 24 * 60 * 60 * 1000;

function dateKeyToUtc(value) {
  const match = String(value || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return null;
  return Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
}

function followsDirectly(previous, next) {
  const previousEnd = dateKeyToUtc(previous?.endDate || previous?.startDate);
  const nextStart = dateKeyToUtc(next?.startDate);
  return previousEnd !== null && nextStart !== null && nextStart - previousEnd === DAY_MS;
}

function sameHolidayKind(left, right) {
  return (
    String(left?.userId || "") === String(right?.userId || "") &&
    String(left?.holidayTypeId || "") === String(right?.holidayTypeId || "") &&
    Boolean(left?.approvalRequired) === Boolean(right?.approvalRequired)
  );
}

function toGroup(segments) {
  if (segments.length === 1) return segments[0];
  const first = segments[0];
  return {
    key: `user-holiday-group:${first.key}`,
    type: "user-holiday",
    entry: first.entry,
    startIndex: Math.min(...segments.map((segment) => segment.startIndex)),
    endIndex: Math.max(...segments.map((segment) => segment.endIndex)),
    segments,
  };
}

/*
  Nimmt die Bereiche einer Rasterzeile ({ key, type, entry, startIndex,
  endIndex }) und fasst anschliessende Ferien zu Gruppen zusammen. Alles
  andere (Absenzen) bleibt unverändert.
*/
export function joinAdjacentUserHolidays(ranges) {
  const holidays = [];
  const others = [];
  (Array.isArray(ranges) ? ranges : []).forEach((range) => {
    (range?.type === "user-holiday" ? holidays : others).push(range);
  });

  holidays.sort(
    (left, right) =>
      String(left.entry?.startDate || "").localeCompare(String(right.entry?.startDate || "")) ||
      left.startIndex - right.startIndex
  );

  const joined = [];
  let current = [];
  holidays.forEach((range) => {
    const previous = current[current.length - 1];
    if (previous && sameHolidayKind(previous.entry, range.entry) && followsDirectly(previous.entry, range.entry)) {
      current.push(range);
      return;
    }
    if (current.length) joined.push(toGroup(current));
    current = [range];
  });
  if (current.length) joined.push(toGroup(current));

  return [...others, ...joined];
}

// Der Teil einer Gruppe, der an diesem Rasterindex liegt (sonst der erste).
export function getHolidaySegmentAt(range, dayIndex) {
  if (!range?.segments?.length) return range;
  return (
    range.segments.find((segment) => dayIndex >= segment.startIndex && dayIndex <= segment.endIndex) ||
    range.segments[0]
  );
}
